import intlTelInput from 'intl-tel-input';
import intlTelInputUtils from '../../../../../node_modules/intl-tel-input/build/js/utils.js';

export default function (formName) {
    const elPhone = document.querySelector('#phone');
    const elPhoneFormatted = document.querySelector('#phone-formatted');
    const preferredCountries = [];

    appData.page.vars.countries.forEach((country) => {
        preferredCountries.push(country.code.toLowerCase());
    });

    const iti = intlTelInput(elPhone, {
        nationalMode: true,
        utilsScript: intlTelInputUtils,
        preferredCountries: preferredCountries,
        initialCountry: appData.trans.localeDefault === 'en' ? 'us' : undefined,
    });

    const handleChange = () => {
        elPhoneFormatted.value = iti.getNumber();
    };

    // listen to "keyup", but also "change" to update when the user selects a country
    elPhone.addEventListener('change', handleChange);
    elPhone.addEventListener('keyup', handleChange);

    document
        .querySelector(`form[name="${formName}"]`)
        .addEventListener('submit', (e) => {
            if (!iti.isValidNumber()) {
                e.preventDefault();

                elPhone.classList.add('is-invalid');
            } else {
                elPhone.classList.remove('is-invalid');
            }
        });
}
